$(() => {
  $('#quickbooks-accounts .qb-account-select').css("width","100%").select2();
});
